import axios from 'axios';

const RESOURCE_NAME = '/custom-fields';

export default {

    getFields(type) {
        return axios.get(`${RESOURCE_NAME}/get-fields?type=${type}`)
    },

    getFieldsNotStatic(type) {
        return axios.get(`${RESOURCE_NAME}/get-fields-not-static?type=${type}`)
    },

    getFieldsWithSections(type) {
        return axios.get(`${RESOURCE_NAME}/get-fields-with-sections?type=${type}`)
    },

    getIndexSections() {
        return axios.get(`${RESOURCE_NAME}/index-sections`)
    },

    getIndexSectionFields(type, id, data) {
        return axios.post(`${RESOURCE_NAME}/index-fields?type=${type}&section_id=${id}`, data)
    },

    getIndexTypeFields(type, data) {
        return axios.post(`${RESOURCE_NAME}/index-fields?type=${type}`, data)
    },

    deleteSection(id) {
        return axios.post(`${RESOURCE_NAME}/delete-section?section_id=${id}`)
    },

    getEdit(id) {
        return axios.get(`${RESOURCE_NAME}/get-edit?id=${id}`)
    },

    save(id, sectionId, data) {
        return axios.post(`${RESOURCE_NAME}/save?id=${id}&section_id=${sectionId}`, data)
    },

    getFieldTypes(type) {
        return axios.get(`${RESOURCE_NAME}/get-field-types?type=${type}`)
    },

    getEditSection(id) {
        return axios.get(`${RESOURCE_NAME}/get-edit-section?section_id=${id}`)
    },

    saveSection(id, data) {
        return axios.post(`${RESOURCE_NAME}/save-section?section_id=${id}`, data)
    },

    getList(type) {
        return axios.get(`${RESOURCE_NAME}/get-list?type=${type}`)
    },

    delete(id) {
        return axios.post(`${RESOURCE_NAME}/delete-field?id=${id}`)
    },

    checkRelations(id) {
        return axios.get(`${RESOURCE_NAME}/check-relations?id=${id}`)
    },

    getChangeLogs(data) {
        return axios.post(`${RESOURCE_NAME}/get-change-logs`, data)
    },

    changeSorting(data) {
        return axios.post(`${RESOURCE_NAME}/change-sorting`, data)
    },

    getFormFields() {
        return axios.get(`${RESOURCE_NAME}/get-form-fields`)
    },

    getOptions(id) {
        return axios.get(`${RESOURCE_NAME}/get-options?id=${id}`)
    },
}